export default {
    install(Vue) {

        Vue.prototype.$convertObjectToObjectsInArray = function(data, keyName, valueName, addIdToName, orderByValue) {
            if (typeof keyName === 'undefined') {
                keyName = 'id';
            }
            if (typeof valueName === 'undefined') {
                valueName = 'name'
            }

            let result = Object.keys(data).map((key) => {
                return {
                    [keyName]:   key,
                    [valueName]: addIdToName ? key + ' - ' + data[key] : data[key]
                };
            });

            if (orderByValue) {
                let sortField = valueName;
                if (typeof orderByValue === "string") {
                    sortField = orderByValue;
                }
                result = result.sort(function(a, b) {
                    if (a[sortField] === b[sortField]) {
                        return 0;
                    } else if (a[sortField] < b[sortField]) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
            }

            return result;
        };

        Vue.prototype.$getExternalValue = function(valueName, fallback)
        {
            let testMode = false;
            let value = window.parent[valueName];
            if (typeof value === 'undefined' && typeof fallback !== 'undefined') {
                value = fallback;
            }

            if (testMode) {
                if (valueName === 'replacementType') {
                    return 'merc';
                } else if (valueName === 'replacementData') {
                    return {
                        "id": "132",
                        "equipment": "carcass",
                        "surveyType": "9",
                        "heightOver8Feet6Inch": "1",
                        "serviceType": null,
                        "viewType": "1",
                        "positionType": null,
                        "machineryManufacturer": null,
                        "machineryType": null,
                        "detailedPosition": null,
                        "componentCode": "RLG",
                        "componentTag": null,
                        "refrigerant": null,
                        "repairCode": "GS",
                        "lengthType": null,
                        "lengthFrom": null,
                        "lengthTo": null,
                        "widthType": null,
                        "widthFrom": null,
                        "widthTo": null,
                        "perimeterType": null,
                        "perimeterFrom": null,
                        "perimeterTo": null,
                        "quantityType": null,
                        "quantityFrom": null,
                        "quantityTo": null,
                        "stsCode1": "2",
                        "stsCode2": "2",
                        "stsCode3": "8",
                        "stsCode4": "6",
                        "maxQuantity": null,
                        "wageHoursPerQuantity": null,
                        "materialCostValue": null,
                        "materialCost": "0",
                        "preparationTime": "0",
                        "mappingDisabled": "0"
                    }
                }
            }

            console.log('loaded external value', valueName, value);

            return value;
        };

        Vue.prototype.$setExternalValue = function(eventName, data)
        {
            let event = new CustomEvent(eventName, { detail: data })
            window.parent.document.dispatchEvent(event)
        }
    }
}